(function () {
	'use strict';

	angular
    .module('app.setup')
    .controller('customerSuccessReport', customerSuccessReport);

	customerSuccessReport.$inject = ['$rootScope', '$scope', '$state', '$timeout'];

	function customerSuccessReport($rootScope, $scope, $state, $timeout) {
		var vm = this;
		var reportSettingsName = 'Customer Success Report';
		var reportSettingsId = $state.params.id;
		var meta = {};

		vm.getMeta = getMeta;

		$scope.type = 'customer';
		$scope.baseReportName = reportSettingsName;

		function getMeta() {
			return meta;
		}
	}
})();